export default "__VITE_ASSET__rPZlZVLU__"